import programme1 from '@/assets/images/IBON-World-Launch-6.jpeg'
import programme2 from '@/assets/images/leaders-group.jpeg'
import programme3 from '@/assets/images/culture-music.jpeg'
import programme4 from '@/assets/images/networking-desk.jpeg'
import type { FeaturedProgramme } from '@/types/programmes'

export const featuredProgrammes: FeaturedProgramme[] = [
  {
    no: '01',
    image: programme1,
    title: 'Africa Caribbean Young Entrepreneurs and Innovation Hub (AfCa-YEIH)',
    description:
      'AfCa-YEIH connects and supports young entrepreneurs from Africa and the Caribbean, providing mentorship, innovation challenges, and cross-regional networks to grow their ventures and drive sustainable economic development.',
  },
  {
    no: '02',
    image: programme2,
    title: 'Technical University Women in Entrepreneurship (TUWE)',
    description:
      'TUWE equips aspiring women entrepreneurs with mentorship, leadership development, and enterprise support to transform ideas into sustainable ventures and pursue economic independence.',
  },
  {
    no: '03',
    image: programme4,
    title: 'Africa Caribbean Student-Preneur & Innovation Hub (AfCaSPIH) Nexus',
    description:
      'A platform that brings together students and entrepreneurs from Africa and the Caribbean to exchange ideas, develop innovative solutions, and build cross-regional networks that inspire enterprise and collaboration.',
  },
  {
    no: '04',
    image: programme3,
    title: 'Africa Caribbean Culture Festival (AfCa-CF)',
    description:
      'AfCa-CF is an annual celebration of African and Caribbean cultural heritage through art, music, dance, fashion, and food, bringing communities together to preserve identity and inspire creative entrepreneurship.',
  },
]
